<template>
  <div>{{ address }}</div>
</template>

<script>
import {assembleAddressForTable} from '@/utilities/utils'

export default {
  props: ['data'],
  computed: {
    address() {
      if (this.data) {
        return assembleAddressForTable(this.data)
      }
    }
  }
}
</script>
